import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();

  return auth ? (
    <Outlet />
  ) : (
    <Navigate 
      to="/login" 
      state={{ fromProtected: true, fromPath: location.pathname }} 
      replace 
    />
  );
};

export default ProtectedRoute;
